import { Component, Input } from '@angular/core';
import { ORDER_STATUS_SEVERITIES } from 'src/app/core/constants';

@Component({
  selector: 'app-order-status-tag',
  templateUrl: './order-status-tag.component.html',
  styleUrls: ['./order-status-tag.component.scss'],
})
export class OrderStatusTagComponent {
  @Input() orderStatus!: string;

  constructor() {}

  getOrderStatusSeverity(status: string): string {
    return (ORDER_STATUS_SEVERITIES as any)[status] || '';
  }
}
